module.exports = __webpack_public_path__ + "static/media/donate.9948fdd7.png";